import classNames from "components/ui/classNames";

/* eslint-disable react/no-array-index-key */
interface LoadingSkeletonProps {
  count: number;
  className?: string;
}
export default function LoadingSkeleton({ count, className }: LoadingSkeletonProps) {
  return (
    <div className="grid grid-cols-1 items-center gap-y-4 w-full">
      {Array.from({ length: count }).map((_, index) => (
        <div
          key={index}
          className={classNames(
            "h-24 w-full animate-pulse rounded-xl bg-slate-100 ring-1 ring-slate-300 ring-offset-2 ring-offset-white",
            "dark:bg-slate-700 dark:ring-slate-700 dark:ring-offset-slate-700",
            className,
          )}
        />
      ))}
    </div>
  );
}
